import { StepperHeader } from './StepperHeader';
import { CurrentUser, StepperStep } from 'types';
import { DynamicForm } from '../DynamicForm';

import styles from './Stepper.module.scss';

export type StepperContentProps = {
  contentWrapperStyles?: string;
  step: StepperStep;
  stepBack?: () => void;
  user?: CurrentUser;
  title: string;
};

export const StepperContent = ({ title, step, contentWrapperStyles, stepBack, user }: StepperContentProps) => {
  return (
    <div className={styles.contentContainer}>
      <StepperHeader title={title} stepBack={stepBack} user={user} />
      <div className={contentWrapperStyles}>
        <DynamicForm {...step.formProps} onSend={step.onPass} marginMode="medium" />
      </div>
    </div>
  );
};
